var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { SpaceRecentListModel } from '../models/space-recent-list-model';
import { SpaceRecentListRepository } from '../repositories/space-recent-list-repository.interface';
let SpaceRecentListServiceImpl = class SpaceRecentListServiceImpl {
    constructor(_spaceRecentListModel, _spaceRecentListRepository) {
        this._spaceRecentListModel = _spaceRecentListModel;
        this._spaceRecentListRepository = _spaceRecentListRepository;
    }
    async getRecentList() {
        const result = await this._spaceRecentListRepository.getRecentList();
        this._spaceRecentListModel.update(() => result);
        return result;
    }
};
SpaceRecentListServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceRecentListModel)),
    __param(1, inject(SpaceRecentListRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceRecentListModel !== "undefined" && SpaceRecentListModel) === "function" ? _a : Object, typeof (_b = typeof SpaceRecentListRepository !== "undefined" && SpaceRecentListRepository) === "function" ? _b : Object])
], SpaceRecentListServiceImpl);
export { SpaceRecentListServiceImpl };
